module.exports = __webpack_public_path__ + "static/media/5 5 tattoo leg tentacruel crystalline aquatic cosmic shimmering.1280x1707.22011ad8.webp";